import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import { compose } from "redux";
import { withTranslation } from "react-i18next";

import * as styles from './style.css';

import StickersComponentsScannerHeader from '../../components/scanner-header';
import Div100vh from "../../../../uq-ui/components/div-100";
import UQButton from "../../../../uq-ui/components/button";
import QRCodeEnter from '../../components/enter-code';
import QRCodeScan from '../../components/scan-code';
import { loadSticker, resetFormErrors } from '../../../store/sticker-show/actions';
import { isMemorialType, stickerShowStateSelector } from '../../../store/sticker-show/selectors';

const exampleImg = require('./img/example.png');

class ScanMethod extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isScanSelected: false,
      isEnterSelected: false,
    };
    this.setupResponsiveStyles();
  }

  componentDidMount() {
    this.props.resetErrors();
  }
  
  setupResponsiveStyles = () => {
    if (window.screen.height < 550) {
      this.controlsContainerStyle = { marginTop: 20, marginBottom: 20 };
    } else {
      this.controlsContainerStyle = { marginTop: 40, marginBottom: 40 };
    }
  };

  onScanPressed = () => {
    this.setState({ 
      isScanSelected: true,
      isEnterSelected: false
    });
    this.props.resetErrors();
  }

  onEnterPressed = () => {
    this.setState({ 
      isScanSelected: false,
      isEnterSelected: true 
    });
    this.props.resetErrors();
  }

  onBackPressed = () => {
    this.setState({ 
      isEnterSelected: false, 
      isScanSelected: false 
    });
    this.props.resetErrors();
  };

  onQrReaded = (id) => {
    this.props.loadSticker(id, { creatingScreen: '' });
  };

  render() {
    const { isScanSelected, isEnterSelected } = this.state;
    const error = this.props.showLlamaState.loadError ? {} : null;

    if (isScanSelected) {
      return (<QRCodeScan goBack={this.onBackPressed}
                          onQREntered={this.onQrReaded}
                          onEnterPressed={this.onEnterPressed}
                          error={error}/>);
    } else if (isEnterSelected) {
      return (<QRCodeEnter goBack={this.onBackPressed}
                           onQREntered={this.onQrReaded}
                           error={error}
                           resetErrors={this.props.resetErrors}/>);
    }
    return (
      <Fragment>
        <StickersComponentsScannerHeader theme="brand" title={this.props.t('headerTitle')}/>
        <Div100vh className={styles.container}>
          <div className={`${styles.title} ${this.props.isMemorialTheme ? styles.titleMemorial : ''} font-title`}>{this.props.t('title')}</div>
          <div className={`${styles.subtitle} ${this.props.isMemorialTheme ? styles.titleMemorial : ''} font-text`}>{this.props.t('subtitle')}</div>
          <div style={this.controlsContainerStyle}>
            <UQButton label={this.props.t('scanBtn')}
                        containerStyle={{ minWidth: 190, whiteSpace: 'nowrap' }}
                        theme={'brand'} 
                        onPress={this.onScanPressed}/>
            <div className={`${styles.or} font-text`}>Or</div>
            <UQButton label={this.props.t('enterBtn')}
                      containerStyle={{ minWidth: 190, whiteSpace: 'nowrap' }}
                      theme={'brand'} 
                      onPress={this.onEnterPressed}/>
          </div>
          <img src={exampleImg} style={{ width: 160, height: 160 }} />
        </Div100vh>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    showLlamaState: stickerShowStateSelector(state),
    isMemorialTheme: isMemorialType(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadSticker: (stickerId, options) => dispatch(loadSticker(stickerId, options)),
    resetErrors: () => dispatch(resetFormErrors()),
  }
};

export default compose(
  withTranslation('scr-scan-method'),
  connect(mapStateToProps, mapDispatchToProps)
)(ScanMethod);



// WEBPACK FOOTER //
// ./src/app/modules/stickers/ui/screens/scan-method/index.jsx